export default __webpack_public_path__ + "static/media/icon-alert.abfe7752.svg";